import { render, staticRenderFns } from "./PaymenStatistics.vue?vue&type=template&id=fb84ef98"
import script from "./PaymenStatistics.vue?vue&type=script&lang=js"
export * from "./PaymenStatistics.vue?vue&type=script&lang=js"
import style0 from "./PaymenStatistics.vue?vue&type=style&index=0&id=fb84ef98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports